export default __webpack_public_path__ + "static/media/howTOopenAndCLoseRegister.f5814522.png";